"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkType = checkType;
/**
 * sprawdza czy typ podanej wartości jest zgodny ze schematem
 * @param schema schemat
 * @param value wartośc do sprawdzenia
 */
function checkType(schema, value) {
    if (value === null) {
        return true;
    }
    switch (schema.type) {
        case 'object':
            return typeof value === 'object';
        case 'array':
            return Array.isArray(value);
        case 'integer':
        case 'number':
        case 'money':
            if (typeof value !== 'number') {
                return false;
            }
            else if (schema.type === 'integer' && value % 1 !== 0) {
                return false;
            }
            else {
                return true;
            }
        case 'string':
            return typeof value === 'string';
        case 'boolean':
            return typeof value === 'boolean';
        default:
            return false;
    }
}
exports.default = checkType;
//# sourceMappingURL=checkType.js.map